import type { PageLoad } from './$types';

export const load: PageLoad = async ({ data }) => {
  if (!data.reviews) {
    throw new Error('Omlouváme se, ale došlo k chybě při načítání stránky. (Error: P2)');
  }
  return data;
};
